export enum MESSAGE_CENTER_EVENTS {
  NEW_MESSAGE_SENT = '.new_message_sent',
  CHAT_CREATED = '.chat_created',
  CHAT_DELETED = '.chat_deleted',
  MESSAGE_DELETED = '.message_deleted',
  MESSAGE_FILE_DELETED = '.message_file_deleted',
}
